import React, { ReactElement } from 'react';
import { Box, ButtonBase, Typography } from '@mui/material';
import { COLORS, FONT, MaterialSymbol } from '../shared';

export interface ActionRowProps {
  eyebrow: string;
  title: string;
  subtitle: string;
  onClick?: () => void;

  isFirst?: boolean;
  isLast?: boolean;
}

export const ActionRow = ({
  eyebrow,
  title,
  subtitle,
  onClick,
  isFirst = false,
  isLast = false,
}: ActionRowProps): ReactElement => (
  <ButtonBase
    onClick={onClick}
    disableRipple
    sx={{
      width: '100%',
      backgroundColor: COLORS.white,
      borderLeft: `1px solid ${COLORS.cardBorder}`,
      borderRight: `1px solid ${COLORS.cardBorder}`,
      borderTop: `1px solid ${COLORS.cardBorder}`,
      borderBottom: isLast ? `1px solid ${COLORS.cardBorder}` : 'none',
      display: 'flex',
      gap: '12px',
      alignItems: 'center',
      p: '14px',
      textAlign: 'left',
      transition: 'background-color 150ms ease',
      '&:hover': { backgroundColor: COLORS.hoverRow },
      '&:active': { backgroundColor: COLORS.pressedRow },
      '&:focus-visible': {
        outline: `2px solid ${COLORS.bodyDark}`,
        outlineOffset: '-2px',
      },
    }}
    data-first={isFirst || undefined}
  >
    <Box
      sx={{
        flex: '1 0 0',
        minWidth: 0,
        display: 'flex',
        flexDirection: 'column',
        gap: '2px',
      }}
    >
      <Typography
        sx={{
          fontFamily: FONT,
          fontWeight: 500,
          fontSize: '12px',
          letterSpacing: '0.6px',
          color: COLORS.bodyDark,
          lineHeight: 'normal',
        }}
      >
        {eyebrow}
      </Typography>
      <Typography
        sx={{
          fontFamily: FONT,
          fontWeight: 600,
          fontSize: '14px',
          lineHeight: '18px',
          color: COLORS.headingDark,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          maxWidth: '100%',
        }}
      >
        {title}
      </Typography>
      <Typography
        sx={{
          fontFamily: FONT,
          fontWeight: 400,
          fontSize: '12px',
          color: COLORS.bodyDark,
          lineHeight: 'normal',
        }}
      >
        {subtitle}
      </Typography>
    </Box>
    <MaterialSymbol name="chevron_right" size={18} color={COLORS.bodyDark} />
  </ButtonBase>
);
